import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const listPropertyResale = (propertyData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_PROPERTY_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project-resale/property-list`,
        propertyData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "LIST_PROPERTY_RESALE_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "LIST_PROPERTY_RESALE_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "LIST_PROPERTY_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewPropertyResale = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VIEW_PROPERTY_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/property-resale/view-property/${id}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "VIEW_PROPERTY_RESALE_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "VIEW_PROPERTY_RESALE_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_PROPERTY_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const statusPropertyResale = (statusData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "STATUS_PROPERTY_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/property-resale/property-status`,
        statusData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "STATUS_PROPERTY_RESALE_SUCCESS",
          payload: data,
        });
        toast.success(data?.message || "Status updated successfully");
        return data;
      } else {
        dispatch({
          type: "STATUS_PROPERTY_RESALE_FAILED",
          payload: data,
        });
        toast.error(data?.message || "Something went wrong");
      }
    } catch (error) {
      dispatch({
        type: "STATUS_PROPERTY_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addAdminMargin = (marginData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_ADMIN_MARGIN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/property-resale/add-admin-margin`,
        marginData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_ADMIN_MARGIN_SUCCESS", payload: data });
        toast.success("Admin Margin Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_ADMIN_MARGIN_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_ADMIN_MARGIN_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Add failed!");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// Update Admin Margin  
export const updateAdminMargin = (marginData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_ADMIN_MARGIN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/property-resale/update-admin-margin`,
        marginData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_ADMIN_MARGIN_SUCCESS", payload: data });
        toast.success("Admin Margin Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_ADMIN_MARGIN_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_ADMIN_MARGIN_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Update failed!");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getMarginHistory = (property_id) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_MARGIN_HISTORY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/property-resale/margin-history/${property_id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_MARGIN_HISTORY_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_MARGIN_HISTORY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_MARGIN_HISTORY_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch margin history!");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const listResaleInterestedProject = (projectData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_RESALE_INTERESTED_PROPERTY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/interested-property/list`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "LIST_RESALE_INTERESTED_PROPERTY_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "LIST_RESALE_INTERESTED_PROPERTY_FAILED", payload: data });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "LIST_RESALE_INTERESTED_PROPERTY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateStatusResaleInterestedProject = (projectData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/interested-property/status/update`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_SUCCESS",
          payload: data,
        });
        // toast.success(data?.message);
        return data;
      } else {
        dispatch({
          type: "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_FAILED",
          payload: data,
        });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const assignProject = (assignData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ASSIGN_PROJECT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/property-resale/assign-project`,
        assignData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ASSIGN_PROJECT_SUCCESS", payload: data });
        // toast.success(data?.message || "Project Assigned Successfully!!");
        return data;
      } else {
        dispatch({ type: "ASSIGN_PROJECT_FAILED", payload: data });
        toast.error(data?.message || "Something went wrong");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ASSIGN_PROJECT_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Assign failed!");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



export const addVR = (addVrData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_VR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/property/update-vr`,
        addVrData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_VR_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_VR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_VR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const removeVr = (removeVrData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REMOVE_VR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/property/remove-vr`,
        removeVrData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_VR_SUCCESS", payload: data });
        toast.success("VR removed successfully!");
        return data;
      } else {
        dispatch({ type: "REMOVE_VR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "REMOVE_VR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const addReel = (addLandmarkData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_REEL_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/file/compress-upload`,
        addLandmarkData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_REEL_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_REEL_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_REEL_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addAR = (arData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/property/addAR`,
        arData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_AR_SUCCESS", payload: data });
        toast.success("AR added successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_AR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listAR = (arListData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LIST_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/property/listAR`,
        arListData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_AR_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_AR_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewAR = (projectId) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/property/viewAR/${projectId}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_AR_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VIEW_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_AR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Error loading AR data");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateAR = (arUpdateData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(
        `${BASE_URL}/property/updateAR/${arUpdateData.id}`,
        arUpdateData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_AR_SUCCESS", payload: data });
        toast.success("AR updated successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_AR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const deleteAR = (deleteData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "DELETE_AR_REQUEST" });

      // ✅ axios.delete doesn't accept a body as 2nd arg like post/put does
      // The correct way is: axios.delete(url, { headers, data: body })
      // But since your backend reads ar_id from req.params, put it in the URL
      const { data } = await axios.delete(
        `${BASE_URL}/property/deleteAR/${deleteData.id}/${deleteData.ar_id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "DELETE_AR_SUCCESS", payload: data });
        // toast.success("AR deleted successfully!");
        return data;
      } else {
        dispatch({ type: "DELETE_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "DELETE_AR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addThreeSixtyPrevVideo = (videoData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_THREE_SIXTY_PREV_VIDEO_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/property/prev-video`,
        videoData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_THREE_SIXTY_PREV_VIDEO_SUCCESS", payload: data });
        toast.success("360° Preview Video added successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_THREE_SIXTY_PREV_VIDEO_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_THREE_SIXTY_PREV_VIDEO_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateThreeSixtyPrevVideo = (videoData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_THREE_SIXTY_PREV_VIDEO_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(
        `${BASE_URL}/property/prev-video/${videoData.project_id}`,
        { three_sixty_prev_video: videoData.three_sixty_prev_video },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_THREE_SIXTY_PREV_VIDEO_SUCCESS", payload: data });
        toast.success("360° Preview Video updated successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_THREE_SIXTY_PREV_VIDEO_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_THREE_SIXTY_PREV_VIDEO_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



export const addReels = (addReelsData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_REELS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/reels/add`,
        addReelsData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_REELS_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_REELS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_REELS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// updateReels.js
export const updateReels = (updateReelsData) => {
  return async (dispatch) => {
    dispatch({ type: "UPDATE_REELS_REQUEST" });
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/reels/update`,
        updateReelsData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_REELS_SUCCESS", payload: data });
        toast.success("Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_REELS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_REELS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// listReels.js
export const listReels = (listReelsData) => {
  return async (dispatch) => {
    dispatch({ type: "LIST_REELS_REQUEST" });
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/reels/list`,
        listReelsData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_REELS_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "LIST_REELS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_REELS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// viewReels.js
export const viewReels = (reelId) => {
  return async (dispatch) => {
    dispatch({ type: "VIEW_REELS_REQUEST" });
    try {
      const { data } = await axios.get(
        `${BASE_URL}/reels/view/${reelId}`
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_REELS_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "VIEW_REELS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_REELS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
